import CabinetShell from '../../features/cabinet/CabinetShell';
import { ONLINE_MANAGER_CABINET } from '../../features/cabinet/configs';

export default function OnlineManagerPage() {
  return <CabinetShell config={ONLINE_MANAGER_CABINET} />;
}
